type LabeledSelectionCheckboxProps = {
  checked: boolean;
  id: string;
  label: string;
  onChange: () => void;
  disabled?: boolean;
};

function LabeledSelectionCheckbox({
  checked,
  id,
  label,
  onChange,
  disabled = false
}: LabeledSelectionCheckboxProps) {
  return (
    <label className={`table-selection-control${disabled ? " table-selection-control-disabled" : ""}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="table-selection-indicator" aria-hidden="true" />
      <span className="visually-hidden">{label}</span>
    </label>
  );
}

export default LabeledSelectionCheckbox;
